<template>
  <component
    :is="resolveLayoutVariant"
    :class="`skin-variant--${appSkinVariant}`"
  >
    <transition
      :name="appRouteTransition"
      mode="out-in"
      appear
    >
      <router-view></router-view>
    </transition>
  </component>
</template>

<script>
import { computed } from '@vue/composition-api'
import useAppConfig from '@core/@app-config/useAppConfig'
import { useRouter } from '@core/utils'
import { useLayout } from '@core/layouts/composable/useLayout'
import useDynamicVh from '@core/utils/useDynamicVh'
import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import LayoutContentHorizontalNav from '@/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue'
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'
import useToggleThemeShortcut from '@/composables/useToggleThemeShortcut'
import useAtendenteTicketsSignalRNotifications from '@/composables/useAtendenteTicketsSignalRNotifications'
import 'vue-toastification/dist/index.css'
import useTokenValidation from './composables/useTokenValidation'
import usePausaValidation from './composables/usePausaValidation'
import { EventBus } from './utils/EventBus'

export default {
  components: {
    LayoutContentVerticalNav,
    LayoutContentHorizontalNav,
    LayoutBlank,
  },

  setup() {
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      if (route.value.meta.layout === 'content') return `layout-content-${appContentLayoutNav.value}-nav`

      return null
    })

    const { closeValidateTokenWebSocket, openValidateTokenWebSocket } = useTokenValidation()

    usePausaValidation()

    EventBus.$on('pausa-iniciada', closeValidateTokenWebSocket)
    EventBus.$on('pausa-finalizada', openValidateTokenWebSocket)

    useDynamicVh()
    useToggleThemeShortcut()

    useAtendenteTicketsSignalRNotifications()

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
    }
  },
}
</script>
